import jsonToView from '../../api/json-to-view';
import calculateDistanceLngLat from './calculate-distance-lnglat';

export default function buildSpotsList(
  data,
  orderDataByDistance,
  showDistances,
  allMarkers,
  searchedPlaceLat,
  searchedPlaceLng
) {
  if (!data || !data.features) {
    return;
  }

  let arrOfSpots = [];

  data.features.forEach(feature => {
    feature.properties.forEach(property => {
      if (property.Latitude != null || property.Longitude != null) {
        if (orderDataByDistance) {
          const fromLat = Number(property.Latitude.replace(',', '.'));
          const fromLng = Number(property.Longitude.replace(',', '.'));
          const toLat = Number(searchedPlaceLat);
          const toLng = Number(searchedPlaceLng);

          const distance = calculateDistanceLngLat(fromLat, fromLng, toLat, toLng);

          const newProperty = { ...property };
          newProperty.Distance = distance.toFixed(1).replace('.', ',');
          arrOfSpots.push(newProperty);
        } else {
          arrOfSpots.push({ ...property });
        }
      }
    });
  });

  arrOfSpots.sort((a, b) => {
    if (orderDataByDistance) {
      const nameA = Number(a.Distance.replace(',', '.'));
      const nameB = Number(b.Distance.replace(',', '.'));
      return nameA - nameB; // numerieke sortering
    }
    const nameA = a.CompanyName.toUpperCase();
    const nameB = b.CompanyName.toUpperCase();

    if (nameA > nameB) return 1;
    if (nameA < nameB) return -1;
    return 0;
  });

  arrOfSpots = arrOfSpots.filter(
    (spot, index, self) => self.findIndex(t => t.Id === spot.Id) === index
  );

  const list = document.querySelector(
    '[data-module="Locator__A"] [data-child-module="Locator__LocationList"]'
  );
  list.innerHTML = '';

  arrOfSpots.forEach(spotItem => {
    const listItem = document.createElement('li');
    listItem.classList.add('c-locationlist__item', 'js-locationlist-item');

    const templateView = 'LocatorSpotListItem';
    jsonToView(spotItem, templateView).then(result => {
      listItem.innerHTML = result;
    });
    list.appendChild(listItem);

    listItem.addEventListener('click', () => {
      const indexOfMarker = allMarkers.findIndex(x => x.id === spotItem.Id);
      google.maps.event.trigger(allMarkers[indexOfMarker], 'click');
    });

    if (showDistances) {
      setTimeout(() => {
        const distances = document.querySelectorAll('[data-module="Locator__LocationDistance"]');
        distances.forEach(distance => {
          distance.removeAttribute('style');
        });
      }, 2000);
    }
  });
}
